module.exports = __webpack_public_path__ + "img/mirror.be5030ca.webp";